import React from 'react';
import bgPattern from "../assets/Onboarding-Form.jpg";
import { useLocation, useNavigate } from 'react-router-dom';
import { generateStorefrontSubmissionPDF } from '../utils/pdfGenerator';

const Row: React.FC<{ label: string; value?: React.ReactNode }> = ({ label, value }) => (
  <div className="flex flex-col gap-1">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-base text-gray-800 whitespace-pre-wrap break-words bg-[#F4F3FF] border border-[#E2D5FF] rounded-xl p-3">
      {value || '-'}
    </div>
  </div>
);

const StorefrontSubmissionSuccessfulPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const formData = location?.state?.formData || {};

  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#E9E3FF] to-[#F8F6FF]">
      <div aria-hidden className="fixed inset-0 -z-10" style={{
        backgroundImage: `url(${bgPattern})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        transform: 'translateZ(0)',
        pointerEvents: 'none'
      }} />

      <div className="container mx-auto px-4" style={{paddingTop: 144, paddingBottom: 90}}>
        <div className="bg-white shadow-md mx-auto p-8 space-y-8" style={{ width: 1160, borderRadius: '20px' }}>
          <div className="text-center">
            <h1 className="font-roboto font-semibold" style={{ fontSize: 36, color: '#4A3B8E' }}>Storefront Submission Successful</h1>
            <p className="mt-2" style={{ color: '#85878B' }}>Here is a summary of what you submitted. You can save this for your records.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Row label="First Name" value={formData.firstName} />
            <Row label="Last Name" value={formData.lastName} />
            <Row label="Email" value={formData.email} />
            <Row label="Brand Name" value={formData.brandName} />
            <Row label="Website" value={formData.website} />
            <Row label="Products & Categories" value={(
              formData.productCountAndCategoriesFileName ? (
                <span>
                  File: {formData.productCountAndCategoriesFileName}
                  {formData.productCountAndCategoriesFileUrl && (
                    <a className="ml-3 underline text-[#564DB8]" href={formData.productCountAndCategoriesFileUrl} download={formData.productCountAndCategoriesFileName}>Download</a>
                  )}
                </span>
              ) : (formData.productCountAndCategories || '')
            )} />
            <Row label="ASINs or Links" value={(
              formData.productAsinsOrLinksFileName ? (
                <span>
                  File: {formData.productAsinsOrLinksFileName}
                  {formData.productAsinsOrLinksFileUrl && (
                    <a className="ml-3 underline text-[#564DB8]" href={formData.productAsinsOrLinksFileUrl} download={formData.productAsinsOrLinksFileName}>Download</a>
                  )}
                </span>
              ) : (formData.productAsinsOrLinks || '')
            )} />
            <Row label="Best Sellers / Heroes" value={formData.bestSellersOrHeroes} />
            <Row label="Brand Mentions / Media" value={formData.hasBrandMentions ? 'Yes' : 'No'} />
            <Row label="Key Features / Benefits" value={formData.keyFeaturesBenefits} />
            <Row label="Target Audience" value={formData.targetAudience} />
            <Row label="Competitor 1" value={formData.competitor1} />
            <Row label="Competitor 2" value={formData.competitor2} />
            <Row label="Competitor 3" value={formData.competitor3} />
            <Row label="Closest Competitor" value={formData.closestCompetitor} />
            <Row label="Likes/Dislikes & Differentiation" value={formData.competitorLikeDislike} />
            <Row label="How you compare" value={formData.brandComparison} />
            <Row label="Brand Tonality" value={formData.brandTonality} />
            <Row label="Inspirations / References" value={formData.inspirationsReferences} />
            <Row label="Desired Design Style" value={formData.desiredDesignStyle} />
            <Row label="Fav Brand 1 Link" value={formData.favBrand1Link} />
            <Row label="Fav Brand 1 Describe" value={formData.favBrand1Describe} />
            <Row label="Fav Brand 2 Link" value={formData.favBrand2Link} />
            <Row label="Fav Brand 2 Describe" value={formData.favBrand2Describe} />
            <Row label="Fav Brand 3 Link" value={formData.favBrand3Link} />
            <Row label="Fav Brand 3 Describe" value={formData.favBrand3Describe} />
          </div>

          <div className="flex flex-col md:flex-row gap-4 pt-4">
            <button onClick={() => navigate('/optimize')} className="w-full md:w-1/3 py-3 font-semibold rounded-lg text-[#4A3B8E] border border-[#4A3B8E]">Go to Start</button>
            <button onClick={() => { const doc = generateStorefrontSubmissionPDF(formData); doc.save('storefront-submission.pdf'); }} className="w-full md:w-2/3 py-3 text-white font-semibold rounded-lg" style={{
              background: 'linear-gradient(90deg, #362E7F 0%, #5A4ABE 45.67%, #7F60BF 100%)'
            }}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorefrontSubmissionSuccessfulPage;


